import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageTitle } from "@/components/DashUI";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { IllustrativeBanner } from "@/components/Disclaimers";
import { AlertTriangle } from "lucide-react";

const money = (n) => "$" + (Math.round(n || 0)).toLocaleString();

export default function Opportunities() {
  const [opps, setOpps] = useState([]);
  useEffect(() => { api.get("/agent/opportunities").then((r) => setOpps(r.data)).catch(() => {}); }, []);
  const active = opps.filter((o) => o.kind === "active" && o.active);
  const illustrative = opps.filter((o) => o.kind === "illustrative");

  return (
    <div>
      <PageTitle title="Available Opportunities" subtitle="Approved provider opportunities and illustrative economics" />
      <IllustrativeBanner className="mb-6" />
      {active.length > 0 && (
        <>
          <h3 className="mb-3 font-heading text-sm font-semibold uppercase tracking-wide text-emeraldbrand">Active opportunities</h3>
          <div className="mb-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {active.map((o) => <OppCard key={o.id} o={o} active />)}
          </div>
        </>
      )}
      <h3 className="mb-3 font-heading text-sm font-semibold uppercase tracking-wide text-slate-500">Illustrative economics</h3>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {illustrative.map((o) => <OppCard key={o.id} o={o} />)}
      </div>
    </div>
  );
}

function OppCard({ o, active }) {
  return (
    <Card className="p-6" data-testid={`agent-opp-${o.id}`}>
      <Badge className={active ? "bg-emeraldbrand/10 text-emeraldbrand hover:bg-emeraldbrand/10" : "bg-amberbrand/10 text-amberbrand hover:bg-amberbrand/10"}>
        {active ? "ACTIVE" : "ILLUSTRATIVE"}
      </Badge>
      <h3 className="mt-3 font-heading text-base font-semibold text-navy">{o.title}</h3>
      <p className="mt-1 text-xs uppercase tracking-wide text-slate-400">{o.service_category}{o.location ? ` · ${o.location}` : ""}</p>
      <p className="mt-3 text-sm text-slate-500">{o.body || o.requirements}</p>
      <div className="mt-4 rounded-lg bg-emeraldbrand/10 p-3">
        <p className="text-xs uppercase tracking-wide text-emeraldbrand">{active ? "Approved commission" : "Illustrative commission"}</p>
        <p className="font-heading text-xl font-bold text-emeraldbrand">{money(o.illustrative_commission)}</p>
      </div>
      {o.compliance_status && o.compliance_status !== "APPROVED" && (
        <p className="mt-3 flex items-center gap-1.5 text-xs font-semibold text-amberbrand">
          <AlertTriangle className="h-3.5 w-3.5" /> {o.compliance_status}
        </p>
      )}
    </Card>
  );
}
